module.exports = __webpack_public_path__ + "static/media/pc_color_no_tagline.17555c47.svg";